export default __webpack_public_path__ + "static/affiliate-program-PartnersAre-4-7478ad8f5285b05fdfdfd01da77d50af.svg";